import {AfterRenderRef, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {ListItemComponent} from '../list-item/list-item.component';
import {CommonModule, NgClass, NgForOf, NgIf} from '@angular/common';
import {ThemeService} from '../../services/theme-service';
import {OrderService} from '../../services/order.service';
import {MenuService} from '../../services/menu.service';
import {ConfigService} from '../../services/config.service';
import {CustomSkin} from '../../models/skin';
import {PageButtonComponent} from '../buttons/page-button.component';
import {AppStateService} from '../../services/app-state.service';
import {MenuUtils, MiscUtils} from '../../utils/Utils';
import {Observable, Subscription} from 'rxjs';
import {Scroll1Directive} from '../../directives/scroll1.directive';
import {filter} from 'rxjs/operators';
import {ItemDetailComponent} from '../item-detail/item-detail.component';
import {MenuItem} from '../../models/FSMenu';
import {BottomSheetData, BottomSheetService} from '../../services/bottom-sheet.service';
import {ModalService} from '../../services/modal.service';
import {WebCodeModalComponent} from '../dialogs/web-code-dialog.component';
import {ExampleModalComponent} from '../dialogs/example-dialog.component';
import {SnackbarService} from '../../services/snackbar.service';
import {ViewportService} from '../../services/viewport-service';
import {BaseButtonComponent} from '../buttons/base-button.component';
import {TranslateService} from '../../services/translate.service';
import {AccountMenuComponent} from '../ui/account-menu.component';
import {VenueMenuComponent} from '../ui/venue-menu.component';
import {PrebookMenusSheetComponent} from '../ui/prebook-menus-sheet.component';
import {PrebookInviteSheetComponent} from '../ui/prebook-invite-sheet.component';
import {FireService} from '../../services/fire.service';
import {PushComponent} from '../push/push.component';
import {SelectDateTimeComponent} from '../ui/select-date-time.component';
import {ProfileInfo} from '../../models/Profile';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import { AuthService } from '../../services/auth.service';
import {CallWaitressDialogComponent} from '../dialogs/call-waitress-dialog.component';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {PrepaidCardComponent} from "../prepaid-card/prepaid-card.component";
import {GiftcardPersonalizedFormComponent} from '../ui/giftcard-personalized-form.component';
import {SendGiftcardEmailComponent} from '../ui/send-giftcard-email.component';
import {NotificationService, NotificationSnapshot} from '../../services/notification.service';
import { SignInComponent } from "../sign-in/sign-in.component";
import {LoyaltyMenuComponent} from '../ui/loyalty-menu.component';
import {AddLoyaltyComponent} from '../ui/add-loyalty.component';
import {LoyaltyCardComponent} from '../ui/loyalty-card.component';
import {SignupLoyaltyComponent} from '../ui/signup-loyalty.component';
import {LoyaltyAgreementComponent} from '../ui/loyalty-agreement.component';
import {SelectLangComponent} from '../ui/select-lang.component';
import { ServingUtil } from '../../utils/serving-util';
import {AppState} from '../../models/AppState';
import {LangPushComponent} from '../ui/lang-push.component';
import {ReviewDetailSheetComponent} from '../ui/review-detail-sheet.component';

export enum LogoShape {
  Rectangle = 'rectangle',
  Circle = 'circle'
}

@Component({
  selector: 'app-menu-base',
  standalone: true,
  imports: [
    RouterOutlet,
    ActionButtonComponent,
    CircleButtonComponent,
    ListItemComponent,
    NgForOf,
    PageButtonComponent,
    Scroll1Directive,
    NgClass,
    ItemDetailComponent,
    NgIf,
    BaseButtonComponent,
    AccountMenuComponent,
    VenueMenuComponent,
    PrebookMenusSheetComponent,
    PrebookInviteSheetComponent,
    PushComponent,
    SelectDateTimeComponent,
    CommonModule,
    LoadingSpinnerComponent,
    PrepaidCardComponent,
    GiftcardPersonalizedFormComponent,
    SendGiftcardEmailComponent,
    SignInComponent,
    LoyaltyMenuComponent,
    SendGiftcardEmailComponent,
    AddLoyaltyComponent,
    LoyaltyCardComponent,
    SignupLoyaltyComponent,
    LoyaltyAgreementComponent,
    SelectLangComponent,
    LangPushComponent,
    ReviewDetailSheetComponent
  ],
  templateUrl: './menu-base.component.html',
  styleUrl: './menu-base.component.css'
})
export class MenuBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  skin: CustomSkin = {
    bgImage: "https://s3-alpha-sig.figma.com/img/919f/53e3/9d212fbe9dc4ac13c6a233454fe2ffc0?Expires=1734912000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=jn34oj~ojfG5K3JHWrG7z-6kafvi0hXTDDnUXO6tMRKq4sj7QYLjPNQq-r1l1HW1B3kD9Dw-FybgIEyJEzdRcis2sSa3TJIXhV8MjAsPoRfNmf1KIFWAlwYFO1lovX7BcUdssiFt4vsf8unqDc21SFfA0z0nKZcVblOjtc~wq6tSy2NwQGY~Kj9SnBXqfUzrSI8twO2fZRRZ0XIv4dyqL7wdu6orfe9ipq~YXIF8aBWxKiQwgiKJf2n70znUfqMKc1j5JBvBrD-45FOduJjd4Jz-Lh9OoQKHOEFQ2m1ijai1mSiGOaoODWuBAFsWVMC5Db4DvnDnjQluqO9HraoH9w__",
  }

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('sheetContent') sheetContent!: ElementRef;

  bgStyle?: string;
  venueName?: string;
  logoBadgeFile?: string;
  logoShape: LogoShape = LogoShape.Rectangle;
  LogoShape = LogoShape;
  private sub?: Subscription;
  private sub2?: Subscription;
  private sub3?: Subscription;
  private sub4?: Subscription;
  private sub5?: Subscription;
  private sub6?: Subscription;

  subTitle?: string = undefined;
  private iOS: boolean = true;
  nativeScroller = false;
  private lastScrollHeight = 0;
  private currentUserId?: number;

  //bottomsheet/item
  isBottomSheetVisible = false;
  isBottomSheetHidden = true;
  activeBottomSheetData: BottomSheetData|null = null;
  pendingBottomSheetData: BottomSheetData|null = null;
  private lastTouchY?: number;
  isScrolled: boolean = false;
  notificationSnapshot?: NotificationSnapshot;
  isAnon?: boolean;
  profileInfo$!: Observable<ProfileInfo | null>;
  private appState?: AppState;
  isTranslationActive: boolean = false;
  isTranslationInProgress: boolean = false;

  showCallForWaitress = false;
  loadTimedOut = false;
  private loadTimeout?: any;

  // Kiosk mode click counter
  private kioskClickCount = 0;
  private kioskClickTimeout: any;

  constructor(private themeService: ThemeService, private router: Router, private route: ActivatedRoute,
              private appStateService: AppStateService,  private bottomSheetService: BottomSheetService,
              private modalService: ModalService, private snackbarService: SnackbarService,
              private viewportService: ViewportService, private translate: TranslateService,
              private auth: AuthService, private api: AuthorizedApiService, private notService: NotificationService,
              private cdRef: ChangeDetectorRef) {
    this.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.nativeScroller = !this.iOS;
    this.profileInfo$ = this.auth.profileInfo$;
  }

  ngOnInit(): void {

    console.log("MenuBaseComponent pageId");

    // Check for URL language parameter early
    this.translate.checkAndProcessUrlLanguage();

    this.loadTimeout = setTimeout(() => {
      if (!this.venueName) {
        this.loadTimedOut = true;
        this.cdRef.detectChanges();
      }
    }, 15000);

    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      this.appState = appState;
      const branding = appState?.cfg.branding;
      if (branding) {
        this.themeService.setTheme(branding);
        this.logoBadgeFile = branding.logo_badge_file

        // Uncomment to use the image aspect ratio to determine the logo shape
        // const img = new Image();
        // img.onload = () => {
        //   this.logoShape = (img.naturalWidth > img.naturalHeight) ? LogoShape.Rectangle : LogoShape.Circle;
        // };
        // img.src = this.logoBadgeFile || '';

      } else {
        //this.themeService.setTheme("light", "outfit");
        this.themeService.setTheme({theme: "light", font: "outfit"});
      }

      let imageUrl;
      if (branding?.background_file) {
        imageUrl = ServingUtil.getDynamicImage(branding.background_file, 0);
      }
      this.bgStyle = "background-image: url(" + imageUrl + ")";

      this.venueName = appState.cfg?.name;
      this.updateSubTitle();
      this.updateCallForWaitress(appState);

      this.isAnon = appState.order.user_cfg.is_anon;
      const userHasChanged = this.checkUserChanged(appState.order.user_cfg.user_id!);
      if (!this.sub4 || userHasChanged) {
        this.sub4?.unsubscribe();
        this.currentUserId = appState.order.user_cfg.user_id;
        this.sub4 = this.notService.observeNotifications(appState.order.user_cfg.chat_id!).subscribe(ns => {
          if (this.appState?.cfg.voucher?.collins_voucher_mode !== "modern") {
            this.notificationSnapshot = ns;
          }
        });
      }

      this.sub5 = this.translate.translationsReceivedSubject.subscribe(() => {
        console.log("MenuBaseComponent translations received");
        //Recived translations for sections make sure angular redraws ui
        this.updateSubTitle();
        this.cdRef.detectChanges();
      });

      this.checkIfUserHasOtherDefaultLangThanSwedishOnce();
    });

    // Subscribe to translation progress
    this.sub6 = this.translate.getTranslationProgress().subscribe(progress => {
      this.isTranslationActive = this.translate.isActive();
      this.isTranslationInProgress = progress.inProgress;
    });

    this.sub2 = this.bottomSheetService.observeActiveSheet().subscribe(bsData => {
      if (this.activeBottomSheetData && bsData) {
        this.pendingBottomSheetData = bsData;
        this.closeBottomSheetWithAnimation();
      } else if (bsData) {
        this.activeBottomSheetData = bsData;
        this.openBottomSheet();
      } else {
        this.closeBottomSheetWithAnimation();
      }
    });

    this.updateShowTopBar(this.router.url);
  }

  private updateSubTitle() {
    if (this.appState?.order?.prebook) {
      // Prebook mode: the banner is the context, no dt title ("Takeaway") in the topbar
      this.subTitle = undefined;
      return;
    }
    const dtcfg= MenuUtils.getDeliverTypeConfig(this.appState?.order?.user_cfg?.dt, this.appState!.cfg);
    this.subTitle = MenuUtils.getDTSubTitle(this.appState, dtcfg, this.translate);
    console.log("subtitle", this.subTitle)
    if (this.subTitle == null) {
      if (this.appState?.order.user_cfg.dt === "table" || this.appState?.order.user_cfg.dt == null) {
        this.subTitle = this.getString('Välj Bord');
      }
    }
  }

  private updateShowTopBar(s: string) {
    this.showTopBar = !s.includes('/start') && !s.includes('/glance');
    this.showSubTitle = !s.includes('/pl');
    this.isBookPage = /\/(queue|waitlist)(\/|\?|$)/.test(s);
  }

  reloadPage() {
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub2?.unsubscribe();
    this.sub3?.unsubscribe();
    this.sub4?.unsubscribe();
    this.sub5?.unsubscribe();
    this.sub6?.unsubscribe();
    clearTimeout(this.loadTimeout);

    // Clean up kiosk click timeout
    if (this.kioskClickTimeout) {
      clearTimeout(this.kioskClickTimeout);
    }
  }

  ngAfterViewInit() {
    this.viewportService.setUpViewport(this.scrollContainer, this.nativeScroller);

    this.setupScrollBehavior();

    this.sheetContent.nativeElement.addEventListener('scroll', () => {
      this.isScrolled = this.sheetContent.nativeElement.scrollTop > 0;
    });
  }

  private setupScrollBehavior() {
    //const container = this.scrollContainer?.nativeElement;
    // if (!this.nativeScroller && container) {
    //   // Store initial content height
    //   this.lastScrollHeight = container.scrollHeight;
    // }

    // Listen for route changes
    this.sub3?.unsubscribe();
    this.sub3 = this.router.events.pipe(filter(ev => ev instanceof NavigationEnd)).subscribe((ev) => {

      // Hide top bar on start page
      this.updateShowTopBar(ev.url);

      if (!this.nativeScroller) {
        if (!ev.url.includes('feed')) {
          //container.scrollTop = 0;
          this.viewportService.scrollToTop();
        }
        // Update container height constraints
        //this.updateContainerHeight();
      }
    });
  }


  enterFullscreen() {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
  }


  private updateContainerHeight() {
    const container = this.scrollContainer.nativeElement;
    const viewportHeight = window.innerHeight;
    const headerHeight = 0; // Adjust based on your header height

    // Calculate available space
    const availableHeight = viewportHeight - headerHeight;

    // Ensure minimum height fills viewport
    if (container.scrollHeight < availableHeight) {
      container.style.minHeight = `${availableHeight}px`;
      container.style.overflowY = 'hidden';
    } else {
      container.style.minHeight = 'auto';
      container.style.overflowY = 'auto';
    }

    // Prevent overscroll
    container.style.maxHeight = `${availableHeight}px`;

    // Update last known scroll height
    this.lastScrollHeight = container.scrollHeight;
  }

  // Helper methods for template
  showTopBar: boolean = true;
  showSubTitle: boolean = true;
  isBookPage: boolean = false;
  getMinHeight(): string {
    //if (this.nativeScroller) return 'auto';
    //return `calc(100vh)`;
    return 'auto';
  }

  getMaxHeight(): string {
    if (this.nativeScroller) return 'none';
    return `calc(100dvh)`;
  }

  private closeBottomSheetWithAnimation() {
    this.isBottomSheetVisible = false;
    const closing = this.activeBottomSheetData;
    // Wait for animation to complete before hiding
    setTimeout(() => {
      // A sheet opened while this one was closing (one opened right as the page starts) stays open
      if (this.activeBottomSheetData !== closing) {
        return;
      }
      this.isBottomSheetHidden = true;
      this.activeBottomSheetData = null;

      // If we have a pending sheet, show it after the current one is closed
      if (this.pendingBottomSheetData) {
        this.activeBottomSheetData = this.pendingBottomSheetData;
        this.pendingBottomSheetData = null;
        this.openBottomSheet();
      }
    }, 300); // Match duration-300
  }

  private openBottomSheet() {
    this.isBottomSheetHidden = false;
    // Force a reflow before setting visible
    requestAnimationFrame(() => {
      this.isBottomSheetVisible = true;
    });

    // Use setTimeout to ensure the DOM has updated after making the sheet visible
    setTimeout(() => {
      if (this.sheetContent?.nativeElement) {
        this.sheetContent.nativeElement.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      }
    });
  }

  private checkUserChanged(userId: number): boolean {
    if (!userId || !this.currentUserId) { return false; }
    return this.currentUserId !== userId;
  }

  closeBottomSheet() {
    this.bottomSheetService.closeSheet();
  }

  onTouchStart(event: TouchEvent) {
    this.lastTouchY = event.touches[0].clientY;
  }

  onScroll(event: WheelEvent | TouchEvent) {
    const element = event.currentTarget as HTMLElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    this.isScrolled = scrollTop > 0;

    if (event instanceof WheelEvent) {
      if (scrollTop <= 0 && event.deltaY < 0) {
        event.preventDefault();
      }
      if (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0) {
        event.preventDefault();
      }
    } else {
      const touchY = event.touches[0].clientY;
      const deltaY = touchY - this.lastTouchY!;
      this.lastTouchY = touchY;

      if ((scrollTop <= 0 && deltaY > 0) ||
        (scrollTop + clientHeight > scrollHeight - 10 && deltaY < 0)) {
        event.preventDefault();
      }
    }
  }

  showModal() {

    // this.snackbarService.showMessage('This is a longer text message that provides more information to the user', 10000, 'Dismiss');
    // this.snackbarService.showMessage('WOW!', 10000, 'Dismiss');

  }

  showExample() {
    this.modalService.show(ExampleModalComponent, {
      data: {
        title: 'En rubrik',
        message: 'Are you sure you want to proceed?',
        confirmText: 'Yes, proceed',
        onConfirm: () => {
          console.log('User confirmed!');
        }
      }
    });
  }

  displayAccountMenu() {
    this.bottomSheetService.displaySheetClass("account-menu", this.getString("Min profil"));
  }

  displayVenueMenu() {
      this.bottomSheetService.displaySheetClass("venue-menu", this.venueName!);
  }

  clickLogo() {
    this.showModal();
  }

  navStart() {
    this.router.navigate([this.appStateService.venueId, "start"]);
  }

  navFeed() {
    if (this.appState?.cfg.voucher?.collins_voucher_mode !== "modern") {
      this.router.navigate([this.appStateService.venueId, "feed"]);
    }
  }

  // Top bar logo click: from the waitlist pages, return to start with from=book
  navHome() {
    if (this.isBookPage) {
      this.router.navigate([this.appStateService.venueId, "start"], { queryParams: { from: "book" } });
    } else {
      this.navStart();
    }
  }

  // Top bar title click: from the waitlist pages, return to start with from=book
  navTitle() {
    if (this.isBookPage) {
      this.router.navigate([this.appStateService.venueId, "start"], { queryParams: { from: "book" } });
    } else {
      this.navFeed();
    }
  }

  getString(s: string) {
    return this.translate.getString(s);
  }

  showPushLang(lang: string) {
    this.translate.observeLangPushScreen(lang).subscribe((translations) => {
      console.log("Translations for lang push:", translations);
      const trl = translations.find(t => t.phrase === "Välj språk");
      this.bottomSheetService.replaceSheet({sheetClass: "push-lang", title: trl?.translation});
    });
  }

  private checkIfUserHasOtherDefaultLangThanSwedishOnce() {
    if (!this.translate.useTranslations) {
      console.log("TRL: Translations not used, skipping language push check.");
      return;
    }

    // Check if we've already shown the language push
    const storeProp = 'hasShownLangPush2';
    const hasShownLangPush = localStorage.getItem(storeProp);
    if (hasShownLangPush) {
      console.log("TRL Language push already shown.");
      return;
    }

    // Get browser language
    const primaryLang = this.translate.getBrowserLang();
    // Offer a switch when the phone's language is not the venue's
    if (primaryLang !== this.translate.venueLang) {
      console.log(`TRL: Language ${primaryLang} is not the venue's ${this.translate.venueLang}, will show push dialog`);
      // Wait then show language push
      setTimeout(() => {
        console.log("TRL: Showing language push dialog");
        this.showPushLang(primaryLang);
        // Mark that we've shown the language push
        localStorage.setItem(storeProp, 'true');
      }, 500);
    }
  }
  isKioskMode(): boolean {
    return this.auth.isKioskMode();
  }

  getKioskState(): string {
    return this.auth.getKioskState();
  }

  displayKioskMenu() {
    this.bottomSheetService.displaySheetClass("select-lang", this.getString("Välj språk"));
  }

  private updateCallForWaitress(appState: AppState) {
    const dtcfg = MenuUtils.getDeliverTypeConfig(appState?.order?.user_cfg?.dt, appState.cfg);
    if (dtcfg) {
      const kioskState = this.auth.getKioskState();
      const isMonterMode = this.auth.isKioskMode() && kioskState === 'monter';
      this.showCallForWaitress = !!(dtcfg.open && dtcfg.call_waiter && appState.order.user_cfg.table != null && !isMonterMode);
    }
  }

  callForWaitress() {
    this.modalService.show(CallWaitressDialogComponent, {
      data: {
        title: this.getString('Kalla på servis?'),
        message: this.getString('Personal kommer och hjälper dig.'),
        confirmText: this.getString('Bekräfta'),
        abortText: this.getString('Avbryt'),
        action: 'callWaitress'
      }
    });
  }

  async handleKioskClick() {
    if (!this.isKioskMode()) {
      return;
    }

    this.kioskClickCount++;

    // Reset counter after 3 seconds if not enough clicks
    if (this.kioskClickTimeout) {
      clearTimeout(this.kioskClickTimeout);
    }

    this.kioskClickTimeout = setTimeout(() => {
      this.kioskClickCount = 0;
    }, 3000);

    // Show dialog after 5 clicks
    if (this.kioskClickCount >= 5) {
      this.kioskClickCount = 0;
      if (this.kioskClickTimeout) {
        clearTimeout(this.kioskClickTimeout);
      }

      // Dynamically import and show the deactivate kiosk mode dialog
      const { DeactivateKioskModeDialogComponent } = await import('../dialogs/deactivate-kiosk-mode-dialog.component');
      this.modalService.show(DeactivateKioskModeDialogComponent, {
        data: {}
      });
    }
  }

}
